var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.87728 0C1.30456 0 0 1.30371 0 2.87492V20.1251C0 21.6965 1.30478 23 2.87728 23H33.2954C34.8682 23 36.1727 21.6963 36.1727 20.1251V2.87492C36.1727 1.30349 34.8679 0 33.2954 0H2.87728ZM4.4315 2.46437H31.7411L18.5361 14.221C18.3536 14.3834 17.8195 14.3834 17.637 14.221L4.4315 2.46437ZM2.46612 4.01732L11.2783 11.8467L2.46612 19.0729V4.01732ZM33.7062 4.01732V19.0729L24.894 11.8467L33.7062 4.01732ZM13.1407 13.5152L16.0053 16.0567C17.2026 17.122 18.9699 17.122 20.1672 16.0567L23.0318 13.5152L31.5872 20.536H4.58603L13.1415 13.5152H13.1407Z","fill":"black"}));
}

Email.defaultProps = {"width":"37","height":"23","viewBox":"0 0 37 23","fill":"none"};

module.exports = Email;

Email.default = Email;
